class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    // Add hover behavior on desktop (min-width: 990px)
    if (window.matchMedia('(min-width: 990px)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      const summary = this.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          // If already open via hover, clicking summary shouldn't close it to avoid flashing
          if (this.mainDetailsToggle.hasAttribute('open')) {
            event.preventDefault();
          }
        });
      }
    }
  }

  onMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      // Close other open menus first to avoid overlapping dropdowns
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
